<gala-filtre (display)="showFiltre($event)" />

<div class="filtre" [hidden]="boFiltreHide">
  <ul>
    <filtre-annee-mois #filtreAnneeMois [titre]="lgTrad.PERIODE" [anneeMois]="filtrePlansTournee.filtrePeriode"
      (periodeChange)="appliqueFiltrePeriode($event); filtrer(true)" />

      <li class="titre">{{translate.instant("FILTER")}}</li>
      <li>
        <select-filtre [options]="filtreOrga" (selected)="filtrer(false)" [placeholder]="lgTrad.ORGANISME"
          optSorted="ASC" />
        </li>
        <li>
          <select-filtre [options]="filtreAgents" (selected)="filtrer(false)" [placeholder]="lgTrad.AGENT"
            optSorted="ASC" />
          </li>
          <li>
            <select-filtre [options]="filtreServices" (selected)="filtrer(false)" [placeholder]="lgTrad.SERVICE"
              optSorted="ASC" />
            </li>
            <li>
              <select-filtre [options]="filtreStatutEve" (selected)="filtrer(false)" [placeholder]="lgTrad.STATUTEVE"
                optSorted="ASC" />
              </li>
            </ul>
            <div class="total">{{translate.instant("FILTERS.TOTAL")}}<span>{{ listeAgentsAffiches.length }}</span></div>
          </div>
          <div>
            <div class="d-flex justify-content-center">
              <h3>{{ filtreAnneeMois.anneeMoisLib }}</h3>
            </div>
            <div class="d-flex justify-content-center">
              <table class="table table-striped table-bordered table-sm text-center">
                <thead class="xs-padding">
                  <tr>
                    <th rowspan="2">{{translate.instant("AGENTS")}}</th>
                    @for (curSemaine of planPeriode?.listeSemaines; track curSemaine) {
                      <th
                        [attr.colspan]="curSemaine.nbJoursSemaine">
                        {{ curSemaine.numSemaine | number:'2.0' }}
                      </th>
                    }
                  </tr>
                  <tr>
                    @for (curJour of planPeriode?.listeJours; track curJour) {
                      <th class="jour">
                        {{ curJour.date | date:'dd' }}<br />
                        {{ curJour.nomJour | slice:0:2 }}
                      </th>
                    }
                  </tr>
                </thead>
                <tbody class="no-padding">
                  @for (curAgent of listeAgentsAffiches; track curAgent) {
                    <tr>
                      <td class="text-left no-wrap agent" dirAgentActivite [agent]="curAgent"
                        [calendrierMode]="CalendrierMode.Mois" [mois]="moisCourant">{{curAgent.NOM }} {{
                      curAgent.PRENOM}}</td>
                      @for (curJour of planPeriode?.listeJours; track curJour) {
                        <td
                          [ngClass]="{'ferie' : curJour.isFerie, 'week-end' : !curJour.isFerie && curJour.isWeekEnd}">
                          <plan-jour-agent [jour]="curJour" [agent]="curAgent" />
                        </td>
                      }
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>